// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2026-02-25T08:47:36Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * @author Štěpán Marek Generated from cz.marbes.eosp.controller.SpravaUctuController.
 */
export default class SpravaUctuApi {
    /**
     * 
     *
     * @param novaRegistraceJmenoHeslo 
     * @return cz.marbes.eosp.controller.vo.UserDataVO
     */
    static novaRegistraceJmenoHeslo(novaRegistraceJmenoHeslo) {
        const uri = serverContextPath + `/api/spravauctu/autentizace/novaRegistraceJmenoHeslo`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, novaRegistraceJmenoHeslo, headers));
    }

    /**
     * Aktivuje daný účet.
     *
     * @param guid 
     * @param aktivaceUctuVO 
     */
    static aktivovatUcet(guid, aktivaceUctuVO) {
        const uri = serverContextPath + `/api/spravauctu/ucty/${guid}/aktivovat`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, aktivaceUctuVO, headers));
    }

    /**
     * Změna hesla.
     *
     * @param changePasswordVO 
     * @return cz.marbes.eosp.controller.vo.ChangePasswordResult
     */
    static changePassword(changePasswordVO) {
        const uri = serverContextPath + `/api/spravauctu/autentizace/zmenitHeslo`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, changePasswordVO, headers));
    }

    /**
     * Reset hesla pro autentizaci jméno a heslo. Při resetu se odešle email s kódem.
     *
     * @param resetHeslaVO 
     */
    static resetovatHeslo(resetHeslaVO) {
        const uri = serverContextPath + `/api/spravauctu/autentizace/resetovatHeslo`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, resetHeslaVO, headers));
    }

    /**
     * 
     *
     * @param guid 
     * @param subjektGuid 
     */
    static removePristup(guid, subjektGuid) {
        const uri = serverContextPath + `/api/spravauctu/ucty/${guid}/pristupy`;
        const headers = undefined;
        const params = { subjektGuid };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * Nastavení resetovaného hesla/prvotní nastavení hesla.
     *
     * @param changeResettedPasswordVO 
     * @return cz.marbes.eosp.controller.vo.TwoFactorOperationVO
     */
    static changeResettedPassword(changeResettedPasswordVO) {
        const uri = serverContextPath + `/api/spravauctu/autentizace/zmenitResetovaneHeslo`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, changeResettedPasswordVO, headers));
    }

    /**
     * Opakování odeslání kódu. @return telefon, na který bylo odesláno, ale pouze jako "### ### 455"
     *
     * @param twoFactorRepeatVO 
     * @return cz.marbes.eosp.controller.vo.TwoFactorOperationVO
     */
    static twoFactorRepeatSms(twoFactorRepeatVO) {
        const uri = serverContextPath + `/api/spravauctu/autentizace/twoFactorRepeatSms`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, twoFactorRepeatVO, headers));
    }

    /**
     * Odebrání přístupů typu NEPRIMY_ZASTUPCE.
     *
     * @param removeSubjektPristupVO 
     */
    static removeSubjektPristup(removeSubjektPristupVO) {
        const uri = serverContextPath + `/api/spravauctu/subjekty/{guid}/pristupy/removeOthers`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, removeSubjektPristupVO, headers));
    }

}
